import { configureStore } from "@reduxjs/toolkit";

import walletReducer, {
  updateWalletData,
  clearWalletData,
  WalletStateProps,
  initialWalletState,
} from "./slices/walletSlice";

import modalReducer, {
  updateModalData,
  clearModallData,
  ModalStateProps,
  initialModalState,
} from "./slices/modalSlice";

import eventReducer, {
  updateEventData,
  EventStateProps,
  initialEventState,
} from "./slices/eventSlice";

import stakeReducer, {
  updateStakeData,
  clearStakeData,
  StakeStateProps,
  initialStakeState,
} from "./slices/stakeSlice";

import userReducer, {
  updateUserData,
  clearUserData,
  UserStateProps,
  initialUserState,
} from "./slices/userSlice";

import globalReducer from "./slices/globalSlice";

export const store: any = configureStore({
  reducer: {
    wallet: walletReducer,
    modal: modalReducer,
    event: eventReducer,
    stake: stakeReducer,
    user: userReducer,
    global: globalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: false,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export {
  updateWalletData,
  clearWalletData,
  initialWalletState,
  updateModalData,
  clearModallData,
  initialModalState,
  updateEventData,
  initialEventState,
  updateStakeData,
  initialStakeState,
  clearStakeData,
  updateUserData,
  clearUserData,
  initialUserState,
};
export type {
  WalletStateProps,
  ModalStateProps,
  EventStateProps,
  StakeStateProps,
  UserStateProps,
};
